import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import { fetchAuthenticated, postWithErrorHandler, post } from 'services/fetch';
import { emitEvent } from 'utils/events';
import { logAction } from 'utils/logs';
import { buildLogString } from "utils/helpers";
import moment from 'moment';

// import NewRfImportForm from 'components/forms/NewRfImportForm';
import NewBipForm from 'components/forms/NewBipForm';
import ModalRemove from 'components/modals/ModalRemove';
import ModalEndProduction from 'components/modals/ModalEndProduction';
import ModalConfirm from "components/modals/ModalConfirm";

const useStyles = makeStyles({
  overlay: {
    position: "absolute",
    height: "100%",
    mouseEvents: "none"
  }
});

export default function EditBip(props) {
  const classes = useStyles();
  const { match, history, setBreadcrumbs } = props;
  const [bip, setBip] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [showProductionDialog, setShowProductionDialog] = useState(false);
  const [loadingDialog, setLoadingDialog] = useState(false);

  const [showEnableDisableDialog, setShowEnableDisableDialog,] = useState(false);

  // Use base equipment url
  const URL = `bip/${match.params.id}`;

  // Set breadcrumbs
  useEffect(() => {
    setBreadcrumbs([
      { path: '/cadastros/bips', label: 'BIPS' },
      { path: '', label: `${bip.orderNumber}` }
    ]);
    return () => { setBreadcrumbs([]); }
  }, [setBreadcrumbs, match.params.id, bip]);

  // Load equipment info
  useEffect(() => {
    const fn = async () => {
      emitEvent('showGlobalLinearProgress');
      const response = await fetchAuthenticated('get', URL);

      // Any error will redirect to equipments list
      if (response.status >= 400) {
        emitEvent('showSnack', { message: 'Não foi possível realizar esta ação', type: 'error' });
        history.push('/cadastros/rf');
      } else {
        const data = await response.json();

        setBip(data);
        // logAction(`Acesso ao cadastro do equipamento ${data.shortImei}`, data.imei)
        emitEvent('hideGlobalLinearProgress');
      }
    }; fn();
  }, [history, URL]);

  // Handle form submission
  const handleSubmit = async (data) => {
    
    if(moment.isMoment(data.date)) {
      data['date'] = data.date.format('YYYY-MM-DD')
    } else {
      const dateYear = data['date'].split('/')[2]
      const dateMonth = data['date'].split('/')[1]
      const dateDay = data['date'].split('/')[0]

      data['date'] = `${dateYear}-${dateMonth}-${dateDay}`
    }

    const response = await fetchAuthenticated('put', URL, data);

    if (!response.ok) {
      throw new Error('')
    } else {
      const data = await response.json();
      setBip(data);
      // logAction(`Edição da importação de RF ${data.shortImei}${updatedItemsStr}`, __equipment.imei);
      emitEvent('showSnack', { message: 'Registro atualizado com sucesso', type: 'success' });
    }
  }

  // Handle cancel button click
  const handleCancel = () => {
    history.push('/cadastros/bips');
  }

  const handleEndProduction = () => {
    setShowProductionDialog(true)
  }

  // Handle remove button click
  const handleRemove = () => {
    console.log('Handle remove');
    setShowDialog(true);
  }

  // Update show dialog variable to close modal
  const handleDialogClose = () => {
    setShowDialog(false);
  }

  // Handle remove confirmation
  const handleRemoveConfirm = async () => {
    setLoadingDialog(true);
    let redirect = false;
    try {
      const response = await fetchAuthenticated('delete', URL);

      if (response.status >= 400) {
        emitEvent('showSnack', { message: 'Não foi possível remover o registro', type: 'error' });
      } else {
        // logAction(`Remoção do equipamento ${equipment.shortImei}`, equipment.imei);
        emitEvent('showSnack', { message: 'Registro removida com sucesso', type: 'success' });
        redirect = true;
      }
    } catch (err) {
      console.log('Error', err);
    } finally {
      setLoadingDialog(false);
      setShowDialog(false);

      // Redirects to user list if everything was ok
      if (redirect) {
        history.push('/cadastros/bips');
      }
    }
  }

  const handleConfirmEndProduction = async () => {
    console.log('ending production')

    const response = await fetchAuthenticated('put', `bip/end-production/${match.params.id}`);

    if (!response.ok) {
      throw new Error('')
    } else {
      const data = await response.json();
      setBip(data);
      // logAction(`Edição da importação de RF ${data.shortImei}${updatedItemsStr}`, __equipment.imei);
      emitEvent('showSnack', { message: 'Produção encerrada com sucesso!', type: 'success' });
    }


  }

  const handleEnableDisable = () => {
    setShowEnableDisableDialog(true);
  }
  const confirmEnableDisable = async () => {
    // const method = equipment.isActive ? 'deactivate'  : 'activate';
    // const path = `${URL}/${method}`;
    // try {
    //   const res = await fetchAuthenticated('put', path);
    //   const eqp = await res.json();
    //   setRfImport(eqp);
    //   setShowEnableDisableDialog(false);
    // } catch (err) {
    //   console.log(err);
    // }
  };

  return (
    <div>
      <NewBipForm
        title='Detalhes do BIP'
        data={bip}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        handleRemove={handleRemove}
        handleEnableDisable={handleEnableDisable}
        handleEndProduction={handleEndProduction}
        isEditing={true}
      />

      <ModalRemove
        isVisible={showDialog}
        setIsVisible={setShowDialog}
        titleLabel='do BIP'
        onSubmit={handleRemoveConfirm}
        isLoading={loadingDialog}
        removeLabel='o BIP'
        extraContent=''
      />

      <ModalEndProduction
        isVisible={showProductionDialog}
        setIsVisible={setShowProductionDialog}
        titleLabel='do BIP'
        onSubmit={handleConfirmEndProduction}
        isLoading={loadingDialog}
        removeLabel='o BIP'
        extraContent=''
      />
    </div>
  );
}
